import { render, staticRenderFns } from "./SIcon.vue?vue&type=template&id=e20dbe7a&scoped=true&lang=pug"
import script from "./SIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./SIcon.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SIcon.vue?vue&type=style&index=0&id=e20dbe7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20dbe7a",
  null
  
)

export default component.exports